import { BaseAction } from "../../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { getPlaceMapsAction } from "../../../LogicActions/Checkout/Seating/GetPlaceMapsAction";
import { IBookingResponse } from "../../../../Orchestrator/Types/Types/BookingTypes";

export class OpenCloseSeatingPopupAction extends BaseAction<void, {
    openModal: boolean, booking?: IBookingResponse,
    isChangeDate?: boolean, isQuickExchange?: boolean,
    isManageSeating?: boolean
}> {

    override async run(): Promise<void | null> {
        try {
            const { openModal, booking, isChangeDate, isQuickExchange, isManageSeating } = this.params!;
            if (booking) {
                const isUpgrade = getRecoilStateValue("isUpgradeToPremiumStateAtom") as boolean;
                if (!isChangeDate || !isQuickExchange || isUpgrade) {
                    getPlaceMapsAction.setParams({ booking: booking, isManageSeating: isManageSeating });
                    await getPlaceMapsAction.execute();
                }
                updateRecoilState("seatSelectorOpenAtom", openModal);
            }
        } catch (error) {
            console.error("Error in OpenCloseSeatingPopupAction:", error);
        }
    }
}

// Create a singleton instance
export const openCloseSeatingPopupAction = new OpenCloseSeatingPopupAction(); 